import { createFileRoute } from "@tanstack/react-router";
import ProductHub from "@/pages/ProductHub";
import { hubArticlesQueryOptions } from "@/lib/hubArticles";

export const Route = createFileRoute("/air-compressors/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(hubArticlesQueryOptions("air-compressors")).catch(() => null);
  },
  component: () => <ProductHub hubSlug="air-compressors" />,
});
